module.exports = __webpack_public_path__ + "static/img/20230710_03.709135c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2023/20230710_03.png
// module id = mwet
// module chunks = 0